export const DEFAULT_MARKET_CHANNEL = "www"
export const MARKET_CHANNELS = ["www", "oci"] as const

export type MarketChannel = (typeof MARKET_CHANNELS)[number]

export function parseMarketChannel(channel: string | undefined): MarketChannel | undefined {
  if (MARKET_CHANNELS.includes(channel as MarketChannel)) {
    return channel as MarketChannel
  }

  return undefined
}

export function isOciMarketChannel(channel: MarketChannel | undefined): boolean {
  return channel === "oci"
}
